import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoLinkedin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.48355 2.9671C2.30289 2.9671 2.9671 2.30289 2.9671 1.48355C2.9671 0.664208 2.30289 0 1.48355 0C0.664208 0 0 0.664208 0 1.48355C0 2.30289 0.664208 2.9671 1.48355 2.9671Z",
			fill: "#0C0C0C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.71984 3.95898H0.247258C0.110772 3.95898 0 4.06976 0 4.20624V11.624C0 11.7605 0.110772 11.8713 0.247258 11.8713H2.71984C2.85633 11.8713 2.9671 11.7605 2.9671 11.624V4.20624C2.9671 4.06976 2.85633 3.95898 2.71984 3.95898Z",
			fill: "#0C0C0C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0883 3.5464C9.03151 3.18442 7.70966 3.50239 6.91695 4.07257C6.88975 3.96625 6.79283 3.88712 6.67761 3.88712H4.20502C4.06854 3.88712 3.95776 3.9979 3.95776 4.13438V11.5521C3.95776 11.6886 4.06854 11.7994 4.20502 11.7994H6.67761C6.81409 11.7994 6.92486 11.6886 6.92486 11.5521V6.22124C7.32443 5.87706 7.83923 5.76728 8.26055 5.94629C8.66902 6.11888 8.90293 6.5402 8.90293 7.10148V11.5521C8.90293 11.6886 9.0137 11.7994 9.15019 11.7994H11.6228C11.7593 11.7994 11.87 11.6886 11.87 11.5521V6.6035C11.8418 4.57153 10.8859 3.81937 10.0883 3.5464Z",
			fill: "#0C0C0C"
		})
	]
});
export { SvgLogoLinkedin as ReactComponent };
